export const safeNumber = (
  value: string | number | null | undefined
): number | undefined => {
  if (value === null || value === undefined) return

  if (typeof value === "number") {
    return value
  }
  const n = parseFloat(value)
  if (isNaN(n)) return
  return n
}
